<div class="tournaments-page">
  <div class="page-head">
    <h1 class="page-title">Create Tournament</h1>
    <button type="button" class="help-toggle" (click)="showHelp = !showHelp">
      {{ showHelp ? 'Hide guide' : 'How to use' }}
    </button>
  </div>

  <div class="help-card" *ngIf="showHelp">
    <h3>How to set up a tournament</h3>
    <ol>
      <li>Give the tournament a name and pick the club where it is played.</li>
      <li>Set the start date and time, plus the deadline for teams to register.</li>
      <li>Choose how many teams can join. Padel formats usually run 4, 6, 8, 12, 16, 32 or 64 teams.</li>
      <li>Pick the team format and the recommended level so players know what to expect.</li>
      <li>Tap the courts that matches will be played on. You can pick more than one.</li>
      <li>Add the prize details if there are any, then publish.</li>
    </ol>
    <p class="help-note">If the team count is not a clean power of two, the draw fills the empty spots with byes so the higher seeds advance automatically in round one.</p>
  </div>

  <form class="create-card" [formGroup]="form" (ngSubmit)="submit()">

    <section>
      <h3 class="section-label">Tournament details</h3>
      <label>Name <input type="text" formControlName="name" placeholder="e.g. Summer Open 2026" /></label>
      <label>Club
        <select formControlName="club_id">
          <option [ngValue]="null" disabled>Pick a club</option>
          <option *ngFor="let c of clubs" [ngValue]="c.id">{{ c.name }}</option>
        </select>
      </label>
      <div class="row">
        <label>Date <input type="date" formControlName="start_date" /></label>
        <label>Start time <input type="time" formControlName="start_time" /></label>
      </div>
    </section>

    <section>
      <h3 class="section-label">Registration</h3>
      <div class="row">
        <label>Admission (€) <input type="number" min="0" step="0.5" formControlName="admission_price" /></label>
        <label>Max teams
          <select formControlName="max_teams">
            <option *ngFor="let n of maxTeamOptions" [ngValue]="n">{{ n }}</option>
          </select>
        </label>
      </div>
      <div class="row">
        <label>Registration deadline date <input type="date" formControlName="registration_deadline_date" /></label>
        <label>Time <input type="time" formControlName="registration_deadline_time" /></label>
      </div>
    </section>

    <section>
      <h3 class="section-label">Format</h3>
      <label>Team format
        <select formControlName="team_format">
          <option *ngFor="let f of teamFormats" [ngValue]="f.value">{{ f.label }}</option>
        </select>
      </label>
      <label>Recommended level
        <select formControlName="level">
          <option *ngFor="let l of levels" [ngValue]="l.value">{{ l.label }}</option>
        </select>
      </label>
    </section>

    <section>
      <h3 class="section-label">Courts</h3>
      <p class="field-label">Courts</p>

      <p class="courts-empty" *ngIf="!form.value.club_id">Pick a club first to see its courts.</p>
      <p class="courts-empty" *ngIf="courtsLoading">Loading courts…</p>
      <p class="courts-empty" *ngIf="form.value.club_id && !courtsLoading && courts.length === 0">
        This club has no courts set up yet.
      </p>

      <div class="court-chips" *ngIf="courts.length">
        <button
          type="button"
          *ngFor="let court of courts"
          class="court-chip"
          [class.selected]="isCourtSelected(court.id)"
          (click)="toggleCourt(court.id)">
          {{ court.label }}
        </button>
      </div>
      <small class="hint" *ngIf="courts.length">Tap the courts matches will be played on. You can pick more than one.</small>
    </section>

    <section>
      <h3 class="section-label">Prize</h3>
      <textarea formControlName="prize_description" maxlength="300" placeholder="e.g. Trophy + €200 cash prize"></textarea>
    </section>

    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <div class="actions">
      <button type="submit" [disabled]="form.invalid || submitting">
        {{ submitting ? 'Publishing…' : 'Publish Tournament' }}
      </button>
    </div>
  </form>
</div>
